/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

// SceneAPI.EBackgroundImageFitType = {
//     FILL: 0,     // no empty space around image, image fills the background but some parts of image re beyond canvas edges
//     FIT: 1       // whole image is visible (there can be empty space on top and bottom or left and right side of the image)
// };

import DrawableObject from "App/environment/drawable_object";
import IScene from "js_interface/src/scene_interface";

export default
class Plane extends DrawableObject {
    constructor(sceneAPI: IScene, gl: WebGLRenderingContext) {
        let attributes = Plane.getDefaultAttributes();

        let indices = [
            0, 1, 2,
            2, 3, 0
        ];

        super(sceneAPI, gl, attributes, indices, 3, 3, 2, false);

        /*
            this._imageFitType = SceneAPI.EBackgroundImageFitType.FILL;
            this._updateScale = false;
        */
    }

    public static getDefaultAttributes() {
        return [
            // Positions      // Normals           // Texture coordinates
             1.0,  1.0, 0.0, 0.0, 0.0, 1.0, 0, 1,
             1.0, -1.0, 0.0, 0.0, 0.0, 1.0, 0, 0,
            -1.0, -1.0, 0.0, 0.0, 0.0, 1.0, 1, 0,
            -1.0,  1.0, 0.0, 0.0, 0.0, 1.0, 1, 1
        ];
    }

    public updateAttributes(attributes: number[]) {
        this._updateVBO(attributes);
    }
}
